export default __webpack_public_path__ + "static/phone-call-dd40ad3e35cfe0839190edd90ab205d6.svg";